import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router';
type LibraryViewNavProps = {
  libraryState: object;
  expandedSubOption?: string;
  mobile?: boolean;
};
const LibraryViewNav: React.SFC<LibraryViewNavProps> = props => {
  const { expandedSubOption, libraryState } = props;
  const { componentId, url: baseUrl } = libraryState;
  //urls
  const summaryUrl = baseUrl + '/summary';
  let submenuOptionsElements = [];
  if (!componentId) {
    return null;
  }
  return (
    <div className="grid" data-automation-id="LibraryViewNav-SideNav-Header">
      <Link
        className={
          'grid__item col-1-1 pv- cursor--pointer link--no-underline' +
          (expandedSubOption === 'library-view'
            ? ' link--primary color--primary'
            : ' hover-background--white-light')
        }
        to={summaryUrl}
      >
        <div className="grid grid--full grid--middle">
          <div className="grid__item col-1-6 font--h6 pl--">
            <i className="sci sci__library sci--fw" />
          </div>
          <div className="grid__item col-5-6 font--h7 pl--">
            <div className="col-1-1 font--h7">Library</div>
            <div className="col-1-1 font--h7">SRCCLR-LID-{componentId}</div>
          </div>
        </div>
      </Link>
      <div
        className={
          'grid__item col-1-1 ' +
          (expandedSubOption === 'library-view' ? ' is-showing-400' : ' is-hiding')
        }
      >
        {submenuOptionsElements}
      </div>
    </div>
  );
};
function mapStateToProps(state) {
  return {
    libraryState: state.libraryState,
  };
}
export default connect(mapStateToProps)(LibraryViewNav);
